export default "__VITE_ASSET__$y3w00qR__"